import React, { useState, useRef, useEffect } from 'react';
// components
import styled from 'styled-components';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';
import { LoadMoreButton } from 'modules/emergencies/components/ui/buttons/LoadMoreButton';
import FixedWithContainer from 'modules/emergencies/components/ui/containers/fixedWithContainer';
import Sticky from 'modules/emergencies/components/ui/sticky/sticky';
import NonSticky from 'modules/emergencies/components/ui/sticky/nonSticky';
import CarriersListTableHeaderRow from './rows/carriersListTableHeaderRow';
import CarrierListTableCarrierRow from './rows/carriersListTableCarrierRow';

const InfiniteLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  ${LoadMoreButton} {
    width: 200px;
  }
`;
const LoaderContainer = styled.div`
  padding-top: 16px;
`;

const ObservableContainer = ({ onObserv, children }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin: '' }
    );
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [isIntersecting]);

  useEffect(() => {
    if (isIntersecting) {
      onObserv();
    }
  }, [isIntersecting, onObserv]);
  return <div ref={ref}>{children}</div>;
};

const CarriersListTable = ({ carriersListData }) => {
  const carriers = carriersListData.carriersData.flat();
  const { isEmpty, isReachingEnd, isLoadingMore } = carriersListData;

  return (
    <>
      <FixedWithContainer>
        <Sticky>
          <CarriersListTableHeaderRow />
        </Sticky>
        <NonSticky>
          {carriers.map((carrier) => (
            <CarrierListTableCarrierRow key={carrier.id} carrier={carrier} />
          ))}
          <InfiniteLoaderContainer>
            {isLoadingMore ? (
              <LoaderContainer>
                <BasicLoader size={10} />
              </LoaderContainer>
            ) : (
              <>
                {!isEmpty && !isReachingEnd && (
                  <ObservableContainer onObserv={carriersListData.loadMore}>
                    <LoaderContainer>
                      <BasicLoader size={10} />
                    </LoaderContainer>
                  </ObservableContainer>
                )}
              </>
            )}
          </InfiniteLoaderContainer>
        </NonSticky>
      </FixedWithContainer>
    </>
  );
};

export default CarriersListTable;
